export default "__VITE_ASSET__gzhCgzHi__"